import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllBrandsList(
  oauthTokenHeader: string,
  biz_layer_query_id: any,
  website_shared_uid: any
) {
  return fetchWrapper.get(
    `${apiUrl}/biz_layer_query/run/${biz_layer_query_id}/?website_shared_uid=${website_shared_uid}`,
    oauthTokenHeader
  );
}
function brandsRunProcess(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/operations/argo/template/`,
    data,
    oauthTokenHeader
  );
}

export const dataCollectionBrandsServices = {
  getAllBrandsList,
  brandsRunProcess,
};
